module.exports = __webpack_public_path__ + "static/media/img3.69ffc271.jpg";